
import {UserSession} from '../contract-features-3/domain';
import {Feature, FeaturesByType, Operation} from '../../../integration/representation/feature';
import datacatalog from '../../../integration/datacatalog/datacatalog-services';
import {FeatureTypeSummary} from '../../../integration/representation/feature-type';
import {Destination} from '../../../integration/representation/contract';
import * as selectors from "./selectors";
export default class DownloadState {
    constructor(
        readonly user: UserSession = null,
        readonly datacatalog: datacatalog = null,
        readonly featureTypes: FeatureTypeSummary[] = [],
        readonly features: Feature[] = [],
        readonly destination: Destination = 'NVDB',
        readonly useProjectRef: boolean = false,
        readonly useContractProjectRef: boolean = true,
        readonly contractProjectRef: string = null,
        readonly customProjectRef: string = null,
        readonly sosiForNvdb123: boolean = false,
        readonly operations: Operation[] = [],
        readonly srid: string = '25832',
        readonly selectedFeatureTypeIds: number[] = [],
        readonly loading: boolean = true,
        readonly loadingFeatures: boolean = false,
        readonly loadingContract: boolean = false,
    ) {}

    private create(overrides: Partial<DownloadState>) {
        const params = {...this, ...overrides};
        const state = new DownloadState(
            params.user,
            params.datacatalog,
            params.featureTypes,
            params.features,
            params.destination,
            params.useProjectRef,
            params.useContractProjectRef,
            params.contractProjectRef,
            params.customProjectRef,
            params.sosiForNvdb123,
            params.operations,
            params.srid,
            params.selectedFeatureTypeIds,
            params.loading,
            params.loadingFeatures,
            params.loadingContract
        );
        return state;
    }

    public withLoadingFeatures(loadingFeatures: boolean) {
        return this.create({loadingFeatures});
    }

    public withLoadingContract(loadingContract: boolean) {
        return this.create({loadingContract})
    }

    public withUser(user: UserSession) {
        return this.create({user});
    }

    public withDatacatalog(datacatalog: datacatalog) {
        return this.create({datacatalog});
    }

    public withFeatureTypes(featureTypes: FeatureTypeSummary[]) {
        return this.create({featureTypes});
    }

    public withFeatures(features: Feature[]) {
        return this.create({features});
    }

    public withDestination(destination: Destination) {
        return this.create({destination});
    }

    public withUseProjectRef(useProjectRef: boolean) {
        return this.create({useProjectRef});
    }

    public withUseContractProjectRef(useContractProjectRef: boolean) {
        return this.create({useContractProjectRef});
    }

    public withContractProjectRef(contractProjectRef: string) {
        return this.create({contractProjectRef});
    }

    public withCustomProjectRef(customProjectRef: string) {
        return this.create({customProjectRef});
    }

    public withSosiForNvdb123(sosiForNvdb123: boolean) {
        return this.create({sosiForNvdb123});
    }

    public withOperations(operations: Operation[]) {
        return this.create({operations});
    }

    public withSrid(srid: string) {
        return this.create({srid});
    }

    public withSelectedFeatureTypeIds(selectedFeatureTypeIds: number[]) {
        return this.create({selectedFeatureTypeIds});
    }

    public withLoading(loading: boolean) {
        return this.create({loading});
    }
 }
